class WelcomeScreenController{

    constructor() {
        var that = this;
        this.passReg = getPasswordCriteria();
        this.profileImage = null;
        this.usernameInput = null;
        this.passwordInput = null;
        this.passwordRepeatInput = null;
        this.emailInput = null;
        this.showPasswordIcon = null;
        this.hidePasswordIcon = null;
        this.showHidePasswordText = null;
        this.correctPasswordIcon = null;
        this.correctPasswordRepeatIcon = null;
        this.saveButton = null;

        $(document).on("click", '#welcomeImageChangeBtn', function() {
            if (world.world_user_icon_mode == 1) {
                $('#welcomeImageInput').trigger('click');
            } else if (world.world_user_icon_mode == 2 || world.world_user_icon_mode == 3) {
                chooseAvatarFullModalController.open(function (url, base64Img) {
                    $('#welcomeImageChangeBtn').css('background-image','url(' + url + ')');
                    that.profileImage = base64Img;//.match(/,(.*)$/)[1];
                }, true);
            }
        });

        $(document).on("change", '#welcomeImageInput', function() {

            var ext = this.files[0]['name'].substring(this.files[0]['name'].lastIndexOf('.') + 1).toLowerCase();

            if (this.files && this.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")){
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('#welcomeImageChangeBtn').css('background-image','url(' + e.target.result + ')');

                    that.profileImage = e.target.result.match(/,(.*)$/)[1];
                }
                reader.readAsDataURL(this.files[0]);
            }
        });

        $(document).off('input.changePassword').on('input.changePassword', '#username-input, #password-input, #password-repeat-input', function() {

            let externalLogin = storage.getItem("external_login");
            let correctPassword = externalLogin === 'true';
            let correctRepeatPassword = externalLogin === 'true';
            let correctUsername = that.usernameInput.length > 0 ? false : true;

            if (!externalLogin) {

                if (that.passwordInput.val().match(that.passReg)) {
                    that.correctPasswordIcon.attr("class", "correct-password-icon password-input-icon");
                    correctPassword = true;
                } else {
                    that.correctPasswordIcon.attr("class", "correct-password-icon password-input-icon d-none");
                    correctPassword = false;
                }

                if (that.passwordRepeatInput.val().length > 0 && that.passwordRepeatInput.val() === that.passwordInput.val()) {
                    that.correctPasswordRepeatIcon.attr("class", "correct-password-icon password-repeat-input-icon");
                    correctRepeatPassword = true;
                } else {
                    that.correctPasswordRepeatIcon.attr("class", "correct-password-icon password-repeat-input-icon d-none");
                    correctRepeatPassword = false;
                }

            }

            if (that.usernameInput.val() && that.usernameInput.val().trim().length > 0) {
                correctUsername = true;
            } else if (that.usernameInput.val()) {
                correctUsername = false;
            }

            if(correctUsername && correctPassword && correctRepeatPassword) {
                that.saveButton.removeClass('disabled');
            } else {
                that.saveButton.addClass('disabled');
            }

            return false;

        });

        $(document).off('focusout.changePassword').on('focusout.changePassword', '#password-input, #password-repeat-input', function() {

            let errorMessage = "";

            if (that.correctPasswordIcon.hasClass('d-none')) {
                errorMessage = Translator.trans('TR_LA_CONTRASENYA_NO_CUMPLE');
            } else if (that.correctPasswordRepeatIcon.hasClass('d-none')) {
                errorMessage = Translator.trans('TR_LAS_CONTRASENYAS_NO_COINCIDEN');
            }

            if (that.correctPasswordIcon.hasClass('d-none') || that.correctPasswordRepeatIcon.hasClass('d-none') && that.passwordRepeatInput.val().length > 0) {
                $.notify({message: errorMessage}, {
                    type: 'danger',
                    delay: 3000,
                    placement: {
                        from: "top",
                        align: "center"
                    },
                    z_index: 1050
                });
            }

        });

        $(document).off('click.confirmPasswordChange').on('click.confirmPasswordChange', '.save-password-button', function(){

            const externalLogin = storage.getItem("external_login");
            const worldToken = world.token;
            const username = that.usernameInput.length > 0 ? that.usernameInput.val() : user.username;
            const name = null;
            const lastName = null;
            const userAvatar = that.profileImage;
            const password = externalLogin ? null : that.passwordInput.val();
            const showFeedback = $('#username-input').length === 0;
            let email = null;

            if (that.emailInput.length > 0 && that.emailInput.val().trim() !== '' && !isValidEmailAddress(that.emailInput.val())) {
                $.notify({message: Translator.trans('TR_EMAIL_NO_VALIDO')}, {
                    type: 'danger',
                    delay: 3000,
                    placement: {
                        from: "top",
                        align: "center"
                    },
                    z_index: 1050
                });

                return false
            } else if (that.emailInput.length > 0 && that.emailInput.val().trim() !== '') {
                email = that.emailInput.val();
            }

            api.postUserInfo(worldToken,username,name,lastName,userAvatar,null,'MENU',password,null, showFeedback);

        });

    };


    draw(result, expiredPassword=false){
        const that = this;

        // Valores cuando el usuario es nuevo
        let title = Translator.trans('TR_BIENVENIDO_TITLE');
        let subtitle = Translator.trans('TR_ANTES_DE_COMENZAR');
        let editableAvatar = true;
        let editableUsername = true;

        // Valores cuando la contrasenya ha caducado
        if (expiredPassword) {
            title = Translator.trans('TR_ACTUALIZA_TU_CONTRASENYA');
            subtitle = Translator.trans('TR_TU_CONTRASENYA_HA_CADUCADO');
            editableAvatar = false;
            editableUsername = false;
        // Valores cuando se le pide desde el manager que cambie la contrasenya
        } else if (result.user.username && result.user.force_password_change) {
            title = Translator.trans('TR_ACTUALIZA_TU_CONTRASENYA');
            subtitle = Translator.trans('TR_NUEVA_CONTRASENYA_LOGIN');
            editableAvatar = false;
            editableUsername = false;
        }

        const context = {
            backgroundImage: world.theme.screen_home_background_image,
            title: title,
            subtitle: subtitle,
            editableAvatar: editableAvatar,
            editableUsername: editableUsername,
            user: user,
            is_lms: result.is_lms,
            show_pass_icon: customIcons["LOGIN_EYE_ON_ICON"],
            hide_pass_icon: customIcons["LOGIN_EYE_OFF_ICON"],
            externalLogin: storage.getItem("external_login") === 'true',
        }

        let template = Handlebars.compile($("#welcomeScreen").html());
        $("#mainContainer").html(template(context));

        tintImage($('#show-password-icon').attr('id'), $('#show-password-icon').attr('data-icon'), world.theme.color_1);
        tintImage($('#hide-password-icon').attr('id'), $('#hide-password-icon').attr('data-icon'), world.theme.color_1);

        this.usernameInput = $('#username-input');
        this.passwordInput = $('#password-input');
        this.passwordRepeatInput = $('#password-repeat-input');
        this.emailInput = $('#email-input');
        this.showPasswordIcon = $('#show-password-icon');
        this.hidePasswordIcon = $('#hide-password-icon');
        this.showHidePasswordText = $('.show-hide-password-text');
        this.correctPasswordIcon = $('.password-input-icon');
        this.correctPasswordRepeatIcon = $('.password-repeat-input-icon');
        this.saveButton = $('.save-password-button');

        $('.show-hide-password-container').off().toggle(
            function(){
                that.passwordInput.hideShowPassword(true);
                that.passwordRepeatInput.hideShowPassword(true);
                that.showPasswordIcon.addClass('d-none');
                that.hidePasswordIcon.removeClass('d-none');
                that.showHidePasswordText.text(Translator.trans('TR_OCULTAR_CONTRASENYAS'));
            },
            function() {
                that.passwordInput.hideShowPassword(false);
                that.passwordRepeatInput.hideShowPassword(false);
                that.showPasswordIcon.removeClass('d-none');
                that.hidePasswordIcon.addClass('d-none');
                that.showHidePasswordText.text(Translator.trans('TR_MOSTRAR_CONTRASENYAS'));
            }
        );

        $("#welcome-form").submit(function(e) {
            e.preventDefault();
        });

        ga('send', 'pageview', analytics.GA_SCREEN_WELCOME);

    };

    drawPolicies(privacyPolicy, usePolicy, showPrivacyRolesBtn, showUseRolesBtn) {

        let template = Handlebars.compile($("#policiesModal").html());

        // Datos para el policiesModal.html
        var context = {
            privacyPolicy: privacyPolicy,
            usePolicy: usePolicy,
            showCloseButton: !showPrivacyRolesBtn && !showUseRolesBtn
        };

        var modalHTML = $('#modalContainer').html(template(context));

        if (privacyPolicy != null) {
            $('#privacy-policy-div').css('border', '1px solid gray');
        } else {
            $('#privacy-policy-section').addClass('hidden');
        }

        if (usePolicy != null) {
            $('#use-policy-div').css('border', '1px solid gray');
        } else {
            $('#use-policy-section').addClass('hidden');
        }

        // Es el espacio extra que queda entre la parte superior e inferior de la pantalla y el modal.
        var spaceHeight = 250;

        $('.modal-body').css({'max-height' : $(document).height() - spaceHeight, 'overflow-y' : 'auto'});

        modalHTML.modal('show');

        $('#policies-modal .policies-accept-btn').height($('#policies-modal .policies-reject-btn').height());

        $(window).resize(function () {
            $('#policies-modal .policies-accept-btn').height($('#policies-modal .policies-reject-btn').height());
        });

        let that = this;

        $('#policies-modal .policies-reject-btn').one('click', function(){
            $('#modalContainer').modal('hide').empty();
            api.rejectPolicies(privacyPolicy, usePolicy);
            that.logoutUser();
        });

        $('#privacy-policy-checkbox-accept, #use-policy-checkbox-accept').change(function () {

            let acceptBtn = $('.policies-accept-btn');
            var condition;

            if (privacyPolicy && usePolicy) {
                condition = $('#privacy-policy-checkbox-accept').is(':checked') && $('#use-policy-checkbox-accept').is(':checked');
            } else if (privacyPolicy) {
                condition = $('#privacy-policy-checkbox-accept').is(':checked');
            } else if (usePolicy) {
                condition = $('#use-policy-checkbox-accept').is(':checked');
            }

            if(condition){
                acceptBtn.addClass('world_color_1_bg');
                acceptBtn.removeClass('bg-disabled');
                acceptBtn.removeAttr('disabled');
            } else {
                acceptBtn.removeClass('world_color_1_bg');
                acceptBtn.addClass('bg-disabled');
                acceptBtn.attr('disabled', true);
            }

        });

        $('#policies-modal .policies-accept-btn').one('click', function(){
            $('#modalContainer').modal('hide').empty();
            api.confirmPolicies(privacyPolicy, usePolicy);
        });

    }

    logoutUser(){
        window.blackBox.logout();

        storage.removeItem('access_token');
        storage.removeItem('external_login');

        ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_LOGOUT,'');

        location.href= Routing.generate('front_office_homepage');
    }
}